import constants from '~/constants'

enum PickUpPoint {
  Golubinskaya = '1',
  Lefortovo = '2',
  Kuzminki = '3'
}

const { Golubinskaya, Kuzminki, Lefortovo } = PickUpPoint

const descriptionMapping = new Map([
  [
    Golubinskaya,
    `—\xA0Адрес: г. Москва, ул. Голубинская, д.\xA04А, стр.\xA02\xA0, эт.\xA02, офис 202 — ст.\xA0м. «Тёплый стан».\n\
—\xA0Режим работы: ежедневно, 10:00\xA0— 18:00.\n\
—\xA0Телефон: ${constants.phoneNumbers.mainWarehouse.formattedText}.`
  ],
  [
    Kuzminki,
    `—\xA0Адрес: г. Москва, ул. Зеленодольская, д.\xA042, эт.\xA02, остров 2—3\xA0— ТРЦ «Кузьминки Молл».\n\
—\xA0Режим работы: ежедневно, 10:00\xA0— 22:00.\n\
—\xA0Телефон: ${constants.phoneNumbers.support.formattedText}.\n\
—\xA0Сроки поступления: 1—4\xA0дня.`
  ],
  [
    Lefortovo,
    `—\xA0Адрес: г. Москва, ш. Энтузиастов, д.\xA012, к.\xA02, эт.\xA01\xA0— ТРЦ «Город Лефортово».\n\
—\xA0Режим работы: ежедневно, 10:00\xA0— 21:00.\n\
—\xA0Телефон: ${constants.phoneNumbers.support.formattedText}.\n\
—\xA0Сроки поступления: 1—4\xA0дня.`
  ]
])

const isActiveMapping = new Map([
  [Golubinskaya, true],
  [Kuzminki, true],
  [Lefortovo, false]
])

const nameMapping = new Map([
  [Golubinskaya, 'Голубинская'],
  [Kuzminki, 'Кузьминки'],
  [Lefortovo, 'Лефортово']
])

namespace PickUpPoint {
  export const sortedMembers = [Golubinskaya, Kuzminki, Lefortovo]

  export function getDescription (pickUpPoint: PickUpPoint): string {
    return descriptionMapping.get(pickUpPoint)!
  }

  export function getName (pickUpPoint: PickUpPoint): string {
    return nameMapping.get(pickUpPoint)!
  }

  export function isActive (pickUpPoint: PickUpPoint): boolean {
    return isActiveMapping.get(pickUpPoint)!
  }
}

export default PickUpPoint
